import React from 'react';
import DateRangePicker, { range } from 'components/Kizen/DateRangePicker';
import { getDateString } from './Date';
import { RangeInputProps } from './types';
import { getFallbackDate } from 'utility/datetime';

const ranges = [
  range.today,
  range.yesterday,
  range.thisMonth,
  range.last7Days,
  range.last30Days,
  range.thisYear,
];

const DEFAULT_RANGE: [Date?, Date?] = [];

type DateRangeProps = RangeInputProps<string | Date> & {
  direction?: string;
  menuStyle?: React.CSSProperties;
};

export const DateRange = ({
  step,
  width = 250,
  value,
  // placeholder, // not making this configurable from the backend until needed
  error,
  onChange,
  direction,
  menuStyle,
}: DateRangeProps) => {
  return (
    <DateRangePicker
      inputAffordance
      ranges={ranges}
      defaultRange={DEFAULT_RANGE}
      width={width}
      value={value}
      hasError={error}
      direction={direction}
      menuStyle={menuStyle}
      onChange={([min, max]: [Date, Date]) => {
        onChange(step, [
          isNaN(min.getTime()) ? min : getDateString(min),
          isNaN(max.getTime()) ? max : getDateString(max),
        ]);
      }}
      onOk={(range: [Date | string, Date | string]) => {
        const min =
          range[0] instanceof Date ? range[0] : getFallbackDate(range[0]);
        const max =
          range[1] instanceof Date ? range[1] : getFallbackDate(range[1]);

        onChange(step, [
          isNaN(min.getTime()) ? min : getDateString(min),
          isNaN(max.getTime()) ? max : getDateString(max),
        ]);
      }}
    />
  );
};
